module.exports = __webpack_public_path__ + "8735dee25c6cd382464f56de10aadf9e.MP3";